// css =>
import "../../BaseStructure.css";
import Styled from "./productBox.module.css";

// icons =>
import TrashIcon from "../../Assets/Icons/trash.png";
import PlusIcon from "../../Assets/Icons/plus-plus.png";
import MinimizeIcon from "../../Assets/Icons/minimize.png";

// pic =>
import NotImage from "../../Assets/Pictures/No_Image.png";

// type =>
import { PRODUCT_BOX_TYPE } from "./productBoxType";

// services =>
import { AddProductToCart, RemoveProductFromCart, DeleteProductFromCart } from "./productBoxService";

// react =>
import { useNavigate } from "react-router-dom";

// context =>
import { useMessage } from "../../Contexts/MessageBoxContext";

// utils =>
import { slugify } from "../../utils/RemoveUrlSpace";

function ProductBox({ productKey, productThumbnail, productName, productCode, productColor, productVariant, productQuantity, productPrice }: PRODUCT_BOX_TYPE) {
    const navigate = useNavigate();
    const { showMessage } = useMessage();

    const handleAddProductToCart = async () => {
        const result = await AddProductToCart(productCode, productColor.id, productVariant?.id);

        if (result?.success) {
            document.location.reload();
            return showMessage("success", result.message);
        }

        return showMessage("error", result.message);
    }

    const handleRemoveProductFromCart = async () => {
        const result = await RemoveProductFromCart(productCode, productColor.id, productVariant?.id);
        
        if (result.success) {
            document.location.reload();
            return showMessage("success", result.message);
        }

        return showMessage("error", result.message);
    }

    const handleDeleteProductFromCart = async () => {
        const result = await DeleteProductFromCart(productKey);

        if (result.success) {
            document.location.reload();
            return showMessage("success", result.message);
        }

        return showMessage("error", result.message);
    }

    return(
        <div className={ Styled.ItemBox } data-aos="fade-up">
            <div className={`row ${ Styled.ProductBoxFrameDesktop }`}>
                <div className={`col-1 ${ Styled.ProductKeyBox }`}>
                    <p>{ productKey }</p>
                </div>

                <div className={`col-10 ${ Styled.ProductBody }`}>
                    <div className="col-2" onClick={() => {
                        navigate(`/product-info/${ slugify(productName) }/${ productCode }`);
                    }}>
                        {
                            productThumbnail ? (
                                <img src={ "https://wedookbrand.com" + productThumbnail } alt={ productName } />
                            ) : (
                                <img src={ NotImage } alt={ productName } />
                            )
                        }
                    </div>
                    <div className="col-2">
                        <p>{ productName }</p>
                    </div>
                    <div className="col-2">
                        <p>{ productCode }</p>
                    </div>
                    <div className={`col-2 `}>
                        <div className={`col-12 ${ Styled.ColorBox }`} style={{ backgroundColor: productColor.color_code }}></div>
                    </div>
                    <div className={`col-2 ${ Styled.QuantityFrame } `}>
                        <img src={ PlusIcon } alt="افزایش" onClick={ handleAddProductToCart } />
                        <p style={{ display: 'inline' }}>{ productQuantity } تعداد</p>
                        <img src={ MinimizeIcon } alt="کمینه" onClick={ handleRemoveProductFromCart } />
                    </div>
                    <div className="col-2">
                        <p>{ productPrice }</p>
                    </div>
                </div>

                <div className={`col-1 ${ Styled.ProductDeleteBox }`} onClick={ handleDeleteProductFromCart }>
                    <img src={ TrashIcon } alt="Trash" />
                </div>
            </div>

            <div className={`row ${ Styled.ProductBoxFrameMobile }`}>
                <div className={`col-3 ${ Styled.PictureSectionFrame } `}>
                    {
                        productThumbnail ? (
                            <img src={ ("https://wedookbrand.com" + productThumbnail) } alt={ productName } />
                        ) : (
                            <img src={ NotImage } alt={ productName } />
                        )
                    }
                </div>

                <div className={`col-8 ${ Styled.ProductInfoSectionFrame } `}>
                    <div className={`row ${ Styled.ProductInfoSection } `}>
                        <div className="col-12">
                            <p>نام محصول : { productName }</p>
                        </div>

                        <div className="col-12">
                            <p>کد محصول : { productCode }</p>
                        </div>

                        <div className="col-6" style={{ float: 'right' }}>
                            <p style={{ marginRight: '-35%' }}>
                                تعداد : 
                                <img src={ PlusIcon } alt="افزایش" onClick={ handleAddProductToCart } />
                                { productQuantity }
                                <img src={ MinimizeIcon } alt="کمینه" onClick={ handleRemoveProductFromCart } />
                            </p>
                        </div>
                        <div className="col-6">
                            <p className={ Styled.ColorText }>رنگ : </p>
                            <div className={`${ Styled.ColorBoxMobile }`} style={{ backgroundColor: productColor.color_code }}></div>
                        </div>

                        <div className="col-12">
                            <p>قیمت : { productPrice }</p>
                        </div>
                    </div>
                </div>

                <div className={`col-1 ${ Styled.TrashSectionFrame } `} onClick={ handleDeleteProductFromCart }>
                    <img src={ TrashIcon } alt="Trash" />
                </div>
            </div>
        </div>
    );
}

export default ProductBox;
